import React, { useState } from "react";
import { trackError } from "../../../../lib/metrics";

export function DrawerPuzzle({ solved, onSolved, sessionCode, playerId, unlocked = false }) {
  const DRAWER_CODE = "623";
  const [input, setInput] = useState("");
  const [feedback, setFeedback] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    const trimmed = input.trim();

    if (trimmed === DRAWER_CODE) {
      setFeedback("✦ Le loquet cède avec un petit clic sec. Tiroir déverrouillé.");
      onSolved?.();
    } else {
      trackError?.({
        sessionCode,
        stage: 1,
        playerId,
        reason: "wrong_drawer_code",
      });
      setFeedback("Ce n’est pas le bon code. Tu entends le mécanisme refuser net.");
    }
  };

  // IMPORTANT : si solved, on n'affiche PLUS les câblages ici.
  if (solved) {
    return (
      <div className="mt-3 rounded-lg bg-black/60 border border-green-500/50 px-3 py-3 text-sm">
        <p>Le tiroir est ouvert.</p>
        {unlocked === false ? (
          <p className="mt-1 text-xs text-gray-300">
            À l’intérieur, il y a un classeur… mais il semble verrouillé.
          </p>
        ) : (
          <p className="mt-1 text-xs text-gray-300">
            Le classeur est dévérouillé.
          </p>
        )}

      </div>
    );
  }

  return (
    <form
      onSubmit={handleSubmit}
      className="mt-3 rounded-lg bg-black/60 border border-white/10 px-3 py-3"
    >
      <p className="text-sm text-gray-200">
        Le tiroir est fermé par une petite serrure à 3 chiffres. À côté du barillet,
        trois petits pictogrammes sont gravés dans le métal :
      </p>

      <div className="mt-3 flex items-center gap-2">
        <span className="inline-flex items-center justify-center w-7 h-7 rounded-md border border-white/30 bg-black/40 text-lg">
          ▲
        </span>
        <span className="inline-flex items-center justify-center w-7 h-7 rounded-md border border-white/30 bg-black/40 text-lg">
          ◯
        </span>
        <span className="inline-flex items-center justify-center w-7 h-7 rounded-md border border-white/30 bg-black/40 text-lg">
          ▭
        </span>

        <input
          type="text"
          maxLength={3}
          value={input}
          onChange={(e) => setInput(e.target.value.replace(/[^0-9]/g, ""))}
          className="w-20 rounded-md border border-gray-500 bg-black/60 px-2 py-1 text-center text-lg tracking-widest"
        />

        <button
          type="submit"
          className="rounded-md bg-indigo-600 px-3 py-2 text-xs font-semibold text-white hover:bg-indigo-500"
        >
          Tester le code
        </button>
      </div>

      {feedback && <p className="mt-2 text-xs text-gray-200">{feedback}</p>}
    </form>
  );
}
